import React, { memo, useRef, useEffect, useState } from "react";
import { audioFileUrl } from "../api-config";
import { recordEvent } from "../components/Analytics";

import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// import shareImage from "../img/share.svg";
// import heartImage from "../img/heart.svg";

import downloadImage from "../img/download.svg";
import backwardImage from "../img/backward.svg";
import fastForwardImage from "../img/fast-forward.svg";

import abmIndustryImage from "../img/abm-industry.png";
import rightArrowImage from "../img/right-arrow.svg";
import telephone2Image from "../img/telephone-2.svg";

import log from "loglevel";
import { dayAndTime } from "../components/Dates";
import { companyLink } from "../components/Links";
import { Link } from "../components/Router";
import { isAfter } from "date-fns";
import {
  FaInfoCircle,
  FaServer,
  FaHandPaper,
  FaCheckSquare,
  FaRegPlayCircle,
} from "react-icons/fa";
import { useSessionContext } from "components/Session";
import getTimeCodeFromNum from "components/PlayerTime";
import SiteHead from "./SiteHead";

import "../sass/call.scss";
import "../sass/schedule-call.scss";

const getCurrentWord = (items, time) => {
  // log.debug("getCurrentWord time:", time);
  if (!items) {
    return null;
  }
  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    const { start_time, end_time, alternatives } = item;
    const start = +start_time;
    const end = +end_time;

    // log.info("BLAH", start, time, end);
    if (start <= time && time <= end) {
      // log.info("Yes", alternatives);
      const content = alternatives[0].content;
      // log.info("Content:", content);
      return { index, content };
    }
  }
  return 0;
};

const getCurrentWordV2 = (
  speakerGroups,
  time,
  currentSpeakerGroupIndex,
  currentWordIndex
) => {
  // log.debug("getCurrentWordV2 time:", time);
  if (!speakerGroups || !time) {
    return { wordIndex: -1, speakerGroupIndex: -1 };
  }
  // log.debug("speakerGroups:", speakerGroups);
  let speakerGroupIndex = Math.max(currentSpeakerGroupIndex, 0);
  let wordIndex = Math.max(currentWordIndex, 0);
  if (time < speakerGroups[speakerGroupIndex].start_times[wordIndex]) {
    // In case of rewind:
    speakerGroupIndex = 0;
    wordIndex = 0;
  }
  while (
    speakerGroupIndex < speakerGroups.length - 1 &&
    time > speakerGroups[speakerGroupIndex + 1].start_times[0]
  ) {
    speakerGroupIndex++;
    wordIndex = 0;
  }
  while (
    wordIndex < speakerGroups[speakerGroupIndex].start_times.length - 1 &&
    time > speakerGroups[speakerGroupIndex].start_times[wordIndex + 1]
  ) {
    wordIndex++;
  }
  return { wordIndex, speakerGroupIndex };
};

const getRelativeWordIndex = ({ startIndex, endIndex, currentWordIndex }) => {
  // log.debug("getRelativeWordIndex startIndex:", startIndex, "endIndex:", endIndex, "currentWordIndex:", currentWordIndex);
  if (startIndex <= currentWordIndex && currentWordIndex <= endIndex) {
    return currentWordIndex - startIndex;
  }
  return -1;
};

const groupItemsBySpeaker = ({ items, segments, version, speaker_groups }) => {
  if (version === 2 || version === 3) {
    // Version 2 is already grouped by speaker, so just return it as is.
    return speaker_groups;
  }
  if (!items || !segments) {
    return null;
  }
  if (items.length === 0 || segments.length === 0) {
    return 0;
  }
  const speakerGroups = [];
  let speakerGroup = {
    speaker: segments[0].speaker_label,
    startIndex: 0,
    items: [],
  };
  let segmentIndex = 0;
  // debugger;
  items.forEach((item, itemIndex) => {
    // log.info("Item:", item);
    const { start_time } = item;
    const itemStartTime = +start_time;
    // debugger;
    while (
      itemStartTime > +segments[segmentIndex].end_time &&
      segmentIndex < segments.length
    ) {
      ++segmentIndex;
    }
    if (segmentIndex >= segments.length) {
      log.info("segment:", segmentIndex, segments.length);
    }
    if (speakerGroup.speaker !== segments[segmentIndex].speaker_label) {
      // debugger;
      speakerGroup.endIndex = itemIndex - 1;
      speakerGroups.push(speakerGroup);
      speakerGroup = {
        speaker: segments[segmentIndex].speaker_label,
        startIndex: itemIndex,
        items: [],
      };
    }
    speakerGroup.endIndex = itemIndex - 1;
    speakerGroup.items.push(item);
  });
  speakerGroups.push(speakerGroup);
  return speakerGroups;
};

const getCurrentTimeAudio = (audioElement) => {
  if (audioElement && audioElement.current) {
    return getTimeCodeFromNum(audioElement.current.currentTime);
  }
  return "-";
};

const getDurationTimeAudio = (duration) => {
  if (duration) {
    return getTimeCodeFromNum(duration);
  }
  return "-";
};

const getPlaybackSpeedPrettyVersion = (playbackSpeed) => {
  log.debug(`getPlaybackSpeedPrettyVersion(${playbackSpeed})`);
  return playbackSpeed.toFixed(1);
};

const AudioControls = ({
  exchange,
  symbol,
  event: { audio_file, year, quarter },
  buildVersion,
  onTimeUpdateHandler,
  audioEventCallback,
  audioElement,
}) => {
  const downloadFileName = `${symbol} ${quarter.toUpperCase()} ${year}.mp3`;
  const stickyDivRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1.0);
  const [volume, setVolume] = useState(100);
  const playbackSpeedPretty = getPlaybackSpeedPrettyVersion(playbackSpeed);

  log.debug(`AudioControls: ${duration}`);
  log.debug(audioElement);

  const play = () => {
    if (audioElement && audioElement.current) {
      audioElement.current.play();
      setIsPlaying(true);
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const pause = () => {
    if (audioElement && audioElement.current) {
      audioElement.current.pause();
      setIsPlaying(false);
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const seekRelative = (offset) => {
    if (audioElement && audioElement.current) {
      audioElement.current.currentTime =
        audioElement.current.currentTime + offset;
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const seekBackward = () => {
    recordEvent({
      name: "SeekBackward",
      exchange,
      symbol,
      year,
      quarter,
      currentTime: audioElement.currentTime,
      buildVersion,
    });
    seekRelative(-15);
  };

  const seekForward = () => {
    recordEvent({
      name: "SeekForward",
      exchange,
      symbol,
      year,
      quarter,
      currentTime: audioElement.currentTime,
      buildVersion,
    });
    seekRelative(30);
    // window.scrollBy(0, 50);
  };

  const onDownloadAudioFileClick = () => {
    recordEvent({
      name: "Download",
      exchange,
      symbol,
      year,
      quarter,
      buildVersion,
    });
  };

  const onError = () => {
    log.debug(`The audio element threw an error.`);
  };

  const onCanPlay = () => {
    // setCanPlay(true);
  };

  const onDurationChanged = () => {
    setDuration(audioElement.current.duration);
  };

  const onTimeUpdate = (event) => {
    onTimeUpdateHandler(event);
  };

  const onPlay = (event) => {
    audioEventCallback(event);
    setIsPlaying(true);
  };

  const onPause = (event) => {
    audioEventCallback(event);
    setIsPlaying(false);
  };

  const onAbort = () => {
    log.debug(`onAbort`);
  };

  const onEnded = () => {
    log.debug(`onEnded`);
  };

  const onSeeked = (event) => {
    log.debug(`onSeeked: ${event.target.currentTime}`);
  };

  const seekBarPositionChanged = (event) => {
    const {
      target: { value },
    } = event;
    log.debug(`seekBarPositionChanged event: ${event} target.value: ${value}`);
    if (audioElement && audioElement.current) {
      const fractionalValue = value / 100.0;
      audioElement.current.currentTime = fractionalValue * duration;
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const playbackSpeedChanged = ({ target: { value } }) => {
    const playbackSpeedAsFloat = parseFloat(value);
    log.debug(`PlaybackSpeed: ${playbackSpeedAsFloat}`);
    setPlaybackSpeed(playbackSpeedAsFloat);
    if (audioElement && audioElement.current) {
      audioElement.current.playbackRate = playbackSpeedAsFloat;
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const volumeSliderChanged = ({ target: { value } }) => {
    log.debug(`Volume: ${value}`);
    setVolume(value);
    if (audioElement && audioElement.current) {
      audioElement.current.volume = value / 100.0;
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const currentTime = getCurrentTimeAudio(audioElement);
  const durationTime = getDurationTimeAudio(duration);

  const seekBarPosition =
    audioElement && audioElement.current
      ? (100 * audioElement.current.currentTime) / duration
      : 0;
  log.debug(`currentTime: ${currentTime} seekBarPosition: ${seekBarPosition}`);

  return (
    <>
      <div className="col-lg-4 mbl-sticky-top">
        <div className="audio-controls" ref={stickyDivRef}>
          <div className="sticky-top-container">
            <div className="player-container">
              <div className="label-content">
                <span className="qno">{quarter.toUpperCase()}</span>
                <span className="title">
                  <Link to={companyLink(exchange, symbol)}>
                    {symbol.toUpperCase()} {year}
                  </Link>
                </span>
                <OverlayTrigger
                  overlay={
                    <Tooltip id="button-tooltip-2">Download Audio File</Tooltip>
                  }
                >
                  <>
                    <a
                      href={audioFileUrl(audio_file)}
                      download={downloadFileName}
                      type="audio/mpeg"
                    >
                      <button
                        type="button"
                        className="btn download without-focus"
                        onClick={onDownloadAudioFileClick}
                      >
                        <img src={downloadImage} alt="icon" />
                      </button>
                    </a>
                  </>
                </OverlayTrigger>
              </div>
              <div className="audio-content">
                <div className="seek-container">
                  <input
                    type="range"
                    min="1"
                    max="100"
                    value={seekBarPosition}
                    onChange={seekBarPositionChanged}
                    className="slider"
                  />
                </div>

                <audio
                  ref={audioElement}
                  onTimeUpdate={onTimeUpdate}
                  onCanPlay={onCanPlay}
                  onPlay={onPlay}
                  onPause={onPause}
                  onDurationChange={onDurationChanged}
                  onError={onError}
                  onEnded={onEnded}
                  onSeeked={onSeeked}
                >
                  <source src={audioFileUrl(audio_file)} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>

              <div className="progress-container">
                <p>{currentTime}</p>
                <p>{durationTime}</p>
              </div>

              <div className="info-actions-section">
                <div className="player-action">
                  <div className="play-control">
                    {isPlaying ? (
                      <button type="button" className="btn" onClick={pause}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="24"
                          viewBox="0 0 16.832 20.47"
                        >
                          <path
                            d="M150.568,0h5.043a.538.538,0,0,1,.568.5V19.969a.538.538,0,0,1-.568.5h-5.043a.538.538,0,0,1-.568-.5V.5A.538.538,0,0,1,150.568,0Zm0,0"
                            transform="translate(-139.347)"
                            fill="#828282"
                          />
                          <path
                            d="M.568,0H5.611a.538.538,0,0,1,.568.5V19.969a.538.538,0,0,1-.568.5H.568a.538.538,0,0,1-.568-.5V.5A.538.538,0,0,1,.568,0Zm0,0"
                            fill="#828282"
                          />
                        </svg>
                      </button>
                    ) : (
                      <button type="button" className="btn" onClick={play}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="24"
                          viewBox="0 0 20 24"
                        >
                          <path
                            d="M11.143,1.429a1,1,0,0,1,1.715,0L23.091,18.486A1,1,0,0,1,22.234,20H1.766a1,1,0,0,1-.857-1.514Z"
                            transform="translate(20) rotate(90)"
                            fill="#828282"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  <ul className="actions-list">
                    <li>
                      <button
                        type="button"
                        className="btn without-focus"
                        onClick={seekBackward}
                      >
                        <img src={backwardImage} alt="icon" />
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        className="btn without-focus"
                        onClick={seekForward}
                      >
                        <img src={fastForwardImage} alt="icon" />
                      </button>
                    </li>

                    <li>
                      <Dropdown>
                        <Dropdown.Toggle
                          className="without-focus p-0"
                          variant="default"
                          id="dropdown-basic"
                          bsPrefix="playSpeedDropdown"
                        >
                          { `${playbackSpeedPretty}x` }
                        </Dropdown.Toggle>

                        <Dropdown.Menu align="right">
                          <div className="play-back-speed popup-container">
                            <div className="lbl">Playback Speed</div>
                            <div className="slider-container">
                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="7.172"
                                  height="8"
                                  viewBox="0 0 7.172 8"
                                >
                                  <path
                                    d="M10.088,1.51a.138.138,0,0,0-.15.031L7.093,4.42V1.638a.138.138,0,0,0-.236-.1L3.041,5.4a.138.138,0,0,0,0,.194L6.857,9.459a.139.139,0,0,0,.236-.1V6.579L9.938,9.459a.138.138,0,0,0,.236-.1V1.638A.139.139,0,0,0,10.088,1.51Z"
                                    transform="translate(-3.001 -1.5)"
                                    fill="#5a5a5a"
                                  />
                                </svg>
                              </span>

                              <span className="slider">
                                <input type="range" min="0.5" step=".1" max="2" value={playbackSpeed} onChange={playbackSpeedChanged} />
                              </span>

                              <span className="icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="7.172"
                                  height="8"
                                  viewBox="0 0 7.172 8"
                                >
                                  <path
                                    d="M3.087,1.51a.138.138,0,0,1,.15.031L6.082,4.42V1.638a.138.138,0,0,1,.236-.1L10.133,5.4a.138.138,0,0,1,0,.194L6.318,9.459a.139.139,0,0,1-.236-.1V6.579L3.237,9.459A.138.138,0,0,1,3,9.362V1.638A.139.139,0,0,1,3.087,1.51Z"
                                    transform="translate(-3.001 -1.5)"
                                    fill="#5a5a5a"
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>

                  <div className="volume-container">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="without-focus p-0"
                        variant="default"
                        id="dropdown-basic"
                        bsPrefix="volumeDropdown"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21.433"
                          height="20.005"
                          viewBox="0 0 21.433 20.005"
                        >
                          <g transform="translate(0 -15.99)">
                            <path
                              d="M12.456,16.061a.712.712,0,0,0-.756.086l-6.95,5.56H1.429A1.431,1.431,0,0,0,0,23.136v5.716A1.43,1.43,0,0,0,1.429,30.28H4.75L11.7,35.84a.715.715,0,0,0,.757.084.713.713,0,0,0,.4-.643V16.706A.717.717,0,0,0,12.456,16.061Z"
                              fill="#828282"
                            />
                            <path
                              d="M342.968,122.458a.715.715,0,1,0-1,1.017,5.7,5.7,0,0,1,0,8.07.714.714,0,1,0,1,1.015,7.127,7.127,0,0,0,0-10.1Z"
                              transform="translate(-326.491 -101.517)"
                              fill="#828282"
                            />
                            <path
                              d="M388.086,77.332a.715.715,0,0,0-1.007,1.015,8.526,8.526,0,0,1,0,12.1.715.715,0,0,0,1.007,1.015,9.958,9.958,0,0,0,0-14.13Z"
                              transform="translate(-369.593 -58.405)"
                              fill="#828282"
                            />
                          </g>
                        </svg>
                      </Dropdown.Toggle>

                      <Dropdown.Menu align="right">
                        <div className="play-back-speed popup-container">
                          <div className="lbl">Volume</div>
                          <div className="slider-container">
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="5.865"
                                height="9.124"
                                viewBox="0 0 5.865 9.124"
                              >
                                <path
                                  d="M5.681,16.023a.325.325,0,0,0-.345.039L2.166,18.6H.652A.653.653,0,0,0,0,19.249v2.607a.652.652,0,0,0,.652.652H2.166l3.169,2.536a.326.326,0,0,0,.345.038.325.325,0,0,0,.184-.293V16.317A.327.327,0,0,0,5.681,16.023Z"
                                  transform="translate(0 -15.99)"
                                  fill="#5a5a5a"
                                />
                              </svg>
                            </span>

                            <span className="slider">
                              <input
                                type="range"
                                min="1"
                                max="100"
                                value={volume}
                                onChange={volumeSliderChanged}
                              />
                            </span>

                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9.775"
                                height="9.124"
                                viewBox="0 0 9.775 9.124"
                              >
                                <path
                                  d="M5.681,16.023a.325.325,0,0,0-.345.039L2.166,18.6H.652A.653.653,0,0,0,0,19.249v2.607a.652.652,0,0,0,.652.652H2.166l3.169,2.536a.326.326,0,0,0,.345.038.325.325,0,0,0,.184-.293V16.317A.327.327,0,0,0,5.681,16.023Z"
                                  transform="translate(0 -15.99)"
                                  fill="#5a5a5a"
                                />
                                <path
                                  d="M342.306,122.346a.326.326,0,0,0-.458.464,2.6,2.6,0,0,1,0,3.681.326.326,0,1,0,.458.463,3.25,3.25,0,0,0,0-4.607Z"
                                  transform="translate(-334.792 -120.089)"
                                  fill="#5a5a5a"
                                />
                                <path
                                  d="M387.423,77.219a.326.326,0,1,0-.459.463,3.888,3.888,0,0,1,0,5.519.326.326,0,0,0,.459.463,4.541,4.541,0,0,0,0-6.444Z"
                                  transform="translate(-378.989 -75.88)"
                                  fill="#5a5a5a"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Player = (props) => {
  log.trace("Player::Render()");
  const {
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date, audio_file },
    transcript,
    isTranscriptPreview,
    buildVersion,
    speakerGroups,
  } = props;
  // log.debug("Player::transcript:", transcript);
  const [audioTime, setAudioTime] = useState();
  const [currentSpeakerGroupIndex, setCurrentSpeakerGroupIndex] = useState(-1);
  const [currentWordIndex, setCurrentWordIndex] = useState(-1);
  const audioElement = useRef(null);

  // https://developer.mozilla.org/en-US/docs/Web/API/Event
  const audioEventCallback = (event) => {
    const {
      type,
      target: { currentTime },
    } = event;
    log.trace("audioEventCallback:", event);
    const eventName = type.charAt(0).toUpperCase() + type.slice(1);
    recordEvent({
      name: eventName,
      exchange,
      symbol,
      year,
      quarter,
      currentTime,
      buildVersion,
    });
  };

  const onTimeUpdateHandler = ({ target: { currentTime } }) => {
    if (!transcript) {
      return;
    }
    // log.info("EVENT:", currentTime);
    setAudioTime(currentTime);
  };

  useEffect(() => {
    if (!transcript) {
      return;
    }
    const { items, version, speaker_groups } = transcript;
    if (!version) {
      return;
    }
    if (version === 2 || version === 3) {
      if (speaker_groups && audioTime) {
        const { wordIndex, speakerGroupIndex } = getCurrentWordV2(
          speaker_groups,
          audioTime,
          currentSpeakerGroupIndex,
          currentWordIndex
        );
        setCurrentSpeakerGroupIndex(speakerGroupIndex);
        setCurrentWordIndex(wordIndex);
      }
    } else {
      const { index } = getCurrentWord(items, audioTime);
      setCurrentWordIndex(index);
    }
  }, [transcript, audioTime, currentSpeakerGroupIndex, currentWordIndex]);

  // https://stackoverflow.com/questions/9563887/setting-html5-audio-position
  // https://stackoverflow.com/questions/48206360/firefox-audio-delay-when-seeking-mp3-file
  const seekTo = (time) => {
    if (audioElement && audioElement.current) {
      log.debug(`seekTo: ${time}`);
      audioElement.current.currentTime = time;
      audioElement.current.play();
    } else {
      log.error("AudioElement is missing:", audioElement);
    }
  };

  const transcriptProps = {
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
    isTranscriptPreview,
    transcript: { version: transcript && transcript.version },
    speakerGroups,
    currentWordIndex,
    currentSpeakerGroupIndex,
    seekTo,
    buildVersion,
  };

  const audioControlsProps = {
    exchange,
    symbol,
    companyName,
    event: { audio_file, year, quarter, conference_date },
    transcript,
    buildVersion,
    onTimeUpdateHandler,
    audioEventCallback,
    audioElement,
  };

  return (
    <>
      <div className="col-lg-8 pr-lg-5">
        <Transcript {...transcriptProps} />
      </div>
      <AudioControls {...audioControlsProps} />
    </>
  );
};

const joinItemsToText = ({ items, version }) => {
  const words = [];
  items.forEach((item, i) => {
    if (version === 2 || version === 3) {
      words.push(item);
    } else {
      const { type, alternatives } = item;
      const content = alternatives[0].content;
      if (type === "punctuation") {
        // Push last word with punctation (no space between).
        if (words.length === 0) {
          words.push(content);
        } else {
          words.push(`${words.pop()}${content}`);
        }
      } else {
        words.push(content);
      }
    }
  });
  return words.join(" ");
};

const TranscriptSection = memo(
  ({ items, wordIndex, seekTo, hasWhitespaceSuffix, version }) => {
    log.trace("TranscriptSection::render() wordIndex:", wordIndex);

    const onClick = (clickEvent) => {
      log.debug("clickEvent:", clickEvent);
      log.debug("items[0]:", items[0]);
      seekTo(items[0].start_time);
    };

    // log.debug("TranscriptSection:: key:", key);

    if (wordIndex === -1) {
      return (
        <>
          <span className="call-text" onClick={onClick}>
            {joinItemsToText({ items, version })}
            {hasWhitespaceSuffix && " "}
          </span>
        </>
      );
    }

    // log.debug("TranscriptSection items:", items);

    const currentItem = items[wordIndex];
    const currentWord =
      version === 2 || version === 3
        ? currentItem
        : currentItem.alternatives[0].content;
    // log.debug("wordIndex:", wordIndex);
    const currentWordType = currentItem.type;
    const wordAfterCurrentWordType =
      wordIndex < items.length - 1 && items[wordIndex + 1].type;
    const lastWord = wordIndex === items.length - 1;
    const textBefore = joinItemsToText({
      items: items.slice(0, wordIndex),
      version,
    });
    const textAfter = joinItemsToText({
      items: items.slice(wordIndex + 1),
      version,
    });

    return (
      <>
        <span className="call-text">
          {textBefore}
          {currentWordType !== "punctuation" && " "}
        </span>
        <span className="current-word">{currentWord}</span>
        {!lastWord && (
          <>
            {wordAfterCurrentWordType !== "punctuation" && " "}
            <span className="call-text">{textAfter}</span>
          </>
        )}
        {hasWhitespaceSuffix && " "}
      </>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.wordIndex === nextProps.wordIndex;
  }
);

const chunkArrayInGroups = (ar, num) => {
  return ar.reduce(function (r, v, i) {
    if (i % num === 0) r.push(ar.slice(i, i + num));
    return r;
  }, []);
};

const hasWhitespaceSuffix = ({ groupIndex, groups }) => {
  if (groupIndex === groups.length - 1) {
    return false;
  }
  const nextGroup = groups[groupIndex + 1];
  return nextGroup[0].type !== "punctuation";
};

const SpeakerSection = memo(
  ({
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
    speaker,
    items,
    words,
    start_times,
    wordIndex,
    seekTo,
    version,
  }) => {
    log.trace("SpeakerSection::render() wordIndex:", wordIndex);
    const WORD_GROUP_SIZE = 20;
    const groups = words
      ? chunkArrayInGroups(words, WORD_GROUP_SIZE)
      : chunkArrayInGroups(items, WORD_GROUP_SIZE);
    const [scrolledIntoView, setScrolledIntoView] = useState(false);
    const speakerSpanRef = useRef(null);
    const sectionStartTime =
      version === 2 || version === 3 ? start_times[0] : items[0].start_time;

    useEffect(() => {
      if (
        wordIndex &&
        wordIndex > -1 &&
        !scrolledIntoView &&
        speakerSpanRef &&
        speakerSpanRef.current
      ) {
        log.debug(`Scrolling speaker ${speaker} into view.`);
        // speakerSpanRef.current.scrollIntoView(true);
        setScrolledIntoView(true);
      }
    }, [scrolledIntoView, wordIndex, speakerSpanRef, speaker]);

    const onPlaySectionClick = () => {
      log.debug("onPlaySectionClick");
      recordEvent({
        name: "PlaySpeakerSection",
        exchange,
        symbol,
        year,
        quarter,
        currentTime: sectionStartTime,
        buildVersion,
      });
      seekTo(sectionStartTime);
    };

    return (
      <>
        <div className="content without-focus">
          <span className="speaker" ref={speakerSpanRef}>
            {speaker}:{" "}
            <button
              className="btn play-speaker-section without-focus"
              onClick={onPlaySectionClick}
              aria-label={`Play ${speaker} at ${sectionStartTime} seconds`}
            >
              <FaRegPlayCircle />
            </button>
          </span>
          <span>
            {groups.map((items, i) => (
              <TranscriptSection
                key={i}
                wordIndex={getRelativeWordIndex({
                  startIndex: WORD_GROUP_SIZE * i,
                  endIndex: WORD_GROUP_SIZE * i + WORD_GROUP_SIZE - 1,
                  currentWordIndex: wordIndex,
                })}
                items={items}
                seekTo={seekTo}
                hasWhitespaceSuffix={hasWhitespaceSuffix({
                  groupIndex: i,
                  groups,
                })}
                version={version}
              />
            ))}
          </span>
        </div>
      </>
    );
  },
  (prevProps, nextProps) => {
    // log.debug("nextProps:", nextProps);
    return prevProps.wordIndex === nextProps.wordIndex;
  }
);

const TranscriptPreviewExplanation = (props) => {
  // debugger;

  const {
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
  } = props;

  const [buttonClicked, setButtonClicked] = useState(false);

  const LetUsKnowButtonClicked = (event) => {
    event.preventDefault();
    setButtonClicked(true);
    recordEvent({
      name: "RequestTranscript",
      exchange,
      symbol,
      year,
      quarter,
      buildVersion,
    });
  };

  return (
    <>
      <div className="about-call">
        <div className="title">Looking for More?</div>
        <div className="content">
          <p className="text">
            This transcript is an excerpt of the full conference call. Right now
            our servers are busy working on other stuff. (<FaServer />) If
            you're interested in the full conference call transcript please let
            us know by clicking the button below.
          </p>
          <Button onClick={LetUsKnowButtonClicked} disabled={buttonClicked}>
            {buttonClicked ? (
              <>
                <FaCheckSquare /> Got it, thanks!
              </>
            ) : (
              <>
                <FaHandPaper /> Request Full Transcript
              </>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

const getSpeakerSectionWordIndex = ({
  activeSpeakerGroup,
  version,
  startIndex,
  endIndex,
  currentWordIndex,
}) => {
  if (version === 2 || version === 3) {
    if (activeSpeakerGroup) {
      return currentWordIndex;
    }
    return -1;
  }
  return getRelativeWordIndex({ startIndex, endIndex, currentWordIndex });
};

const Transcript = ({
  exchange,
  symbol,
  companyName,
  event: { year, quarter, conference_date },
  isTranscriptPreview,
  transcript: { version },
  currentSpeakerGroupIndex,
  currentWordIndex,
  seekTo,
  speakerGroups,
  buildVersion,
}) => {
  log.trace("Transcript::Render() currentWordIndex:", currentWordIndex);
  const {
    sessionContext: { isAdminUser },
  } = useSessionContext();
  const transcriptTitle = `${companyName} — ${quarter.toUpperCase()} ${year} Earnings Conference Call`;
  const conferenceDate = new Date(conference_date);
  const { date, day, time } = dayAndTime(conferenceDate);
  // log.debug("Day time:", date, day, time);
  // log.debug("speakerGroups:", speakerGroups);
  // debugger;
  const transcriptPreviewExplanationProps = {
    exchange,
    symbol,
    event: { year, quarter },
    buildVersion,
  };

  return (
    <>
      <div className="call-text-container">
        <div className="mb-md-4 mb-3">
          <h1 className="title">
            <Link to={companyLink(exchange, symbol)}>{companyName}</Link>
          </h1>
          <h2 className="sub-title">
            <span className="d-inline-block mr-3">
              {`${quarter.toUpperCase()} ${year} Earnings Conference Call`}
              <span className="ml-1">
                <OverlayTrigger
                  overlay={
                    <Tooltip>
                      Conference Call Transcripts are computer generated and may
                      contain errors.
                    </Tooltip>
                  }
                >
                  <FaInfoCircle />
                </OverlayTrigger>
              </span>
            </span>
            <p className="conference-date">{date}</p>
          </h2>
          {isAdminUser && <p>Transcript Version: {version || 1}</p>}
        </div>
        <div className="content-container">
          {speakerGroups ? (
            <>
              {speakerGroups.map(
                (
                  { speaker, startIndex, endIndex, items, words, start_times },
                  i
                ) => {
                  // log.debug("speakerGroup:", i, speaker, startIndex, endIndex, items, words, start_times);
                  return (
                    <SpeakerSection
                      key={i}
                      exchange={exchange}
                      symbol={symbol}
                      event={{ year, quarter }}
                      buildVersion={buildVersion}
                      wordIndex={getSpeakerSectionWordIndex({
                        activeSpeakerGroup: i === currentSpeakerGroupIndex,
                        version,
                        startIndex,
                        endIndex,
                        currentWordIndex,
                      })}
                      speaker={speaker}
                      items={items}
                      words={words}
                      start_times={start_times}
                      seekTo={seekTo}
                      version={version}
                    />
                  );
                }
              )}
            </>
          ) : (
            <p>We are missing the transcript for this call. Sorry!</p>
          )}
        </div>
      </div>
      {isTranscriptPreview && (
        <TranscriptPreviewExplanation {...transcriptPreviewExplanationProps} />
      )}
      <div className="about-call">
        <div className="title">Disclaimer</div>
        <div className="content">
          <p className="text">
            This conference call transcript was computer generated and almost
            certianly contains errors. This transcript is provided for
            information purposes only.
            <strong> Earnings Call, LLC </strong> makes no representation about
            the accuracy of the aforementioned transcript, and you are cautioned
            not to place undue reliance on the information provided by the
            transcript.
          </p>
        </div>
      </div>
    </>
  );
};

const MissingAudio = (props) => {
  const {
    isApproved,
    optOut,
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
  } = props;
  log.debug(year, quarter.toUpperCase());
  log.debug("conference_date:", conference_date);
  const conferenceDate = new Date(conference_date);
  const today = new Date();
  const { date, day, time } = dayAndTime(conferenceDate);
  log.debug("Day time:", date, day, time);

  return (
    <>
      <section className="schedule-call-section">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="content">
                <div className="qno">{quarter.toUpperCase()}</div>

                <div className="cm-name">
                  <div className="img-container invisible">
                    <img src={abmIndustryImage} alt={`${companyName} Logo`} />
                  </div>
                  <Link to={companyLink(exchange, symbol)}>
                    <h3 className="name">{companyName}</h3>
                  </Link>
                </div>
                {isAfter(conferenceDate, today) ? (
                  <>
                    <div className="text">
                      This earning call is scheduled to happen on
                    </div>

                    <div className="schedule">
                      <span className="info">
                        {date} at {time}
                      </span>
                    </div>

                    <div className="lnk-container">
                      <div className="btn without-focus">
                        Please check back later
                        <span className="icon">
                          <img src={rightArrowImage} alt="icon" />
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text">This earning call took place on</div>

                    <div className="schedule">
                      <span className="info">
                        {date} at {time}
                      </span>
                    </div>

                    <div className="lnk-container">
                      <div className="btn without-focus">
                        { optOut ?
                          <>
                            This company has opted-out of earnings calls.
                          </>
                          :
                          <>
                            {isApproved
                            ? "But it looks like we're missing the audio. Please check back later."
                            : "But we're waiting for approval before publishing this call.  Please check back later."}
                          </>
                        }
                        <span className="icon">
                          <img src={rightArrowImage} alt="icon" />
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="img-container">
                <img src={telephone2Image} alt="Call Is Scheduled" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const EarningsEvent = (props) => {
  log.debug("EarningsEvent::Render()", props);
  const {
    event: { audio_file },
    transcript,
    isApproved,
    optOut,
  } = props;
  const { items, speaker_labels, version, speaker_groups } = transcript || {};
  const { segments } = speaker_labels || {};
  const speakerGroups = groupItemsBySpeaker({
    items,
    segments,
    version,
    speaker_groups,
  });

  if (optOut || !audio_file || !isApproved) {
    return <MissingAudio {...props} />;
  }

  const playerProps = { ...props, speakerGroups };
  return (
    <>
      <section className="call-section">
        <div className="container">
          <div className="row">
            <Player {...playerProps} />
          </div>
        </div>
      </section>
    </>
  );
};

const Call = (props) => {
  log.debug("Call::props", props);
  const { pageContext } = props;
  const {
    exchange,
    symbol,
    companyName,
    event: { year, quarter },
  } = pageContext;
  // const { siteMetadata: { buildVersion } } = site;

  useEffect(() => {
    recordEvent({
      name: "Call",
      exchange,
      symbol,
      year,
      quarter
    });
  }, [exchange, symbol, year, quarter]);

  useEffect(() => {
    const onScroll = (args) => {
      // log.debug(`${window.innerHeight} + ${window.pageYOffset} = ${window.innerHeight + window.pageYOffset} <> ${document.body.offsetHeight} <> ${document.body.scrollHeight}`);
    };
    const onWindowEvent = (args) => {
      log.debug(`windowEvent: ${args}`);
      const windowWidth = window.innerWidth;
      log.debug("windowWidth:", windowWidth);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onWindowEvent);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onWindowEvent);
    };
  }, []);

  return (
    <>
      <SiteHead
        title={`EarningsCall · ${symbol.toUpperCase()} ${quarter.toUpperCase()} ${year}`}
        description={`${companyName} — ${symbol.toUpperCase()} ${quarter.toUpperCase()} ${year} Earnings Conference Call`}
        pageProps={props}
      />
      <EarningsEvent {...pageContext} />
    </>
  );
};

export { Call };
